/**
 * 打つ欄は、欄を離れたとき先頭から見える（S-00009、docs/44 §10 の e・docs/10 §9.20）。
 * 長い値の末尾まで打って欄を離れると、ブラウザによっては流した位置のまま残る（Safari）。離れた瞬間に先頭へ戻す。
 * 入りきらない分は styles.css の text-overflow: ellipsis で「…」（押すと欄の中で全部を流して見られる）
 */
const TEXT_TYPES = new Set(["text", "search", "email", "tel", "url", "password", ""]);

export function installInputStart(): void {
  document.addEventListener(
    "focusout",
    (e) => {
      const t = e.target;
      if (t instanceof HTMLInputElement && TEXT_TYPES.has(t.type)) t.scrollLeft = 0;
    },
    true,
  );
}
